<template>
  <field-group
    class="my-1"
    :label="label"
    inline
    v-if="fields && fields.length > 0"
    :items="fields"
    v-model="currentValue"
    :item-text="option.itemText || 'name'"
    :item-value="option.itemValue || 'name'"
    type-input="v-select"
  ></field-group>
  <field-group
    class="my-1"
    :label="label"
    inline
    v-else
    v-model="currentValue"
  ></field-group>
</template>

<script>
export default {
  props: {
    value: {},
    label: String,
    fields: { type: Array },
    option: { type: Object, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {},
}
</script>

<style scoped></style>
